// soracom-statuspage.js
// Configures Statuspal widget translations based on browser locale.
// For non-Japanese browsers, excludes 'ja' from translations to prevent
// the widget from falling back to Japanese (Soracom status page default).
(function() {
    // Guard for SSR/headless environments where navigator may be undefined
    var nav = typeof navigator === 'undefined' ? {} : navigator;

    // Detect browser locale using same method as Statuspal widget
    var browserLocale = (nav.userLanguage || nav.language || 'en').toLowerCase();
    var browserLang = browserLocale.split(/[-_]/)[0];
    var isJapanese = browserLang === 'ja';

    // Translation definitions
    var enBadgeTranslations = {
        status: {
            ok: 'All Systems Operational',
            scheduled: 'Ongoing Scheduled Maintenance',
            minor: 'Ongoing Minor Incident',
            major: 'Ongoing Major Incident'
        }
    };

    var jaBadgeTranslations = {
        status: {
            ok: '全システム正常稼働中',
            scheduled: 'メンテナンス中',
            minor: '軽度の障害が発生中',
            major: '重大な障害が発生中'
        }
    };

    var enBannerTranslations = {
        view_details: 'View Details',
        incident_history: 'Incident History',
        subscribe_updates: 'Subscribe to Updates'
    };

    var jaBannerTranslations = {
        view_details: '詳細を表示',
        incident_history: 'インシデント履歴',
        subscribe_updates: '更新情報を購読'
    };

    // Build translations: include 'ja' only for Japanese browsers.
    // For non-Japanese browsers, excluding 'ja' prevents fallback to Japanese
    // because:
    // - Badge lookup: s[browserLang] || s[statusPageDefault] || s['en']
    //   Without 'ja' in config, s['ja'] is undefined, falls through to s['en']
    // - Banner lookup: requires locale in BOTH config AND API translations
    //   Without 'ja' in config, fails condition and falls through to 'en'
    var badgeTranslations = { en: enBadgeTranslations };
    var bannerTranslations = { en: enBannerTranslations };

    if (isJapanese) {
        badgeTranslations.ja = jaBadgeTranslations;
        bannerTranslations.ja = jaBannerTranslations;
    }

    window.statuspalWidget = {
        subdomain: 'status-soracom',
        locale: isJapanese ? 'ja' : 'en',
        badge: {
            enabled: true,
            selector: '.sp-status',
            position: 'bottom',
            translations: badgeTranslations
        },
        banner: {
            enabled: true,
            position: 'bottom-left',
            translations: bannerTranslations
        }
    };
})();
